import Helper from '../../services/Helper';
let navigation = {};

let user = Helper.getUser();

if (user) {
    let { roleId } = user;

    if (roleId === 1) {
        navigation = {
            items: [
                {
                    name: 'Home',
                    url: '/home',
                    icon: 'icon-home'
                },
                {
                    title: true,
                    name: 'Assessor',
                    wrapper: {
                        // optional wrapper object
                        element: '', // required valid HTML5 element tag
                        attributes: {} // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: '' // optional class names space delimited list for title item ex: "text-center"
                },
                {
                    name: 'Dashboard AFC',
                    url: '/dashboard',
                    icon: 'icon-speedometer'
                },
                {
                    name: 'Input Assessment AFC',
                    url: '/input-asesment',
                    icon: 'icon-note'
                },
                {
                    name: 'Change Role',
                    url: '/change-role',
                    icon: 'fa fa-address-card'
                },
                {
                    title: true,
                    name: 'Menu Admin',
                    wrapper: {
                        // optional wrapper object
                        element: '', // required valid HTML5 element tag
                        attributes: {} // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: '' // optional class names space delimited list for title item ex: "text-center"
                },
                {
                    name: 'Data Assessment',
                    url: '/data-asesment',
                    icon: 'icon-doc'
                },
                {
                    name: 'Master Data',
                    url: '/jenis-perusahaan',
                    icon: 'icon-graph',
                    children: [
                        {
                            name: 'Master Perusahaan',
                            url: '/master-parent-perusahaan'
                        },
                        {
                            name: 'Plant / Instalasi Perusahaan',
                            url: '/master-perusahaan'
                        },
                        {
                            name: 'Jenis Kriteria',
                            url: '/master-jenis-kriteria'
                        },
                        {
                            name: 'User',
                            url: '/master-user'
                        },
                        {
                            name: 'Sheet',
                            url: '/master-sheet'
                        },
                        {
                            name: 'Setting Bobot & Nilai Program',
                            url: '/setting-bobot'
                        },
                        {
                            name: 'Setting Tahun Aktif',
                            url: '/master-tahun'
                        },
                    ]
                },
                {
                    name: 'Logs',
                    url: '/logs',
                    icon: 'icon-logs'
                },
            ]
        };
    } else if (roleId === 2) {
        navigation = {
            items: [
                {
                    name: 'Home',
                    url: '/home',
                    icon: 'icon-home'
                },
                {
                    title: true,
                    name: 'Assessor',
                    wrapper: {
                        // optional wrapper object
                        element: '', // required valid HTML5 element tag
                        attributes: {} // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: '' // optional class names space delimited list for title item ex: "text-center"
                },
                {
                    name: 'Dashboard AFC',
                    url: '/dashboard',
                    icon: 'icon-speedometer'
                },
                {
                    name: 'Change Role',
                    url: '/change-role',
                    icon: 'fa fa-address-card'
                },
                {
                    name: 'Atur User',
                    url: '/master-user',
                    icon: 'icon-note'
                }
            ]
        };
        
    } else if (roleId === 3) {
        navigation = {
            items: [
                {
                    name: 'Home',
                    url: '/home',
                    icon: 'icon-home'
                },
                {
                    title: true,
                    name: 'Menu Pimpinan',
                    wrapper: {
                        // optional wrapper object
                        element: '', // required valid HTML5 element tag
                        attributes: {} // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: '' // optional class names space delimited list for title item ex: "text-center"
                },
                {
                    name: 'Lihat Assessment',
                    url: '/lihat-asesment',
                    icon: 'icon-note'
                },
                // di hide atas permintaan
                // {
                //     name: 'Data Assessment',
                //     url: '/data-asesment',
                //     icon: 'icon-doc'
                // },
                {
                    name: 'Change Role',
                    url: '/change-role',
                    icon: 'fa fa-address-card'
                }
            ]
        };
    } else if (roleId === 4) {
        navigation = {
            items: [
                {
                    name: 'Home',
                    url: '/home',
                    icon: 'icon-home'
                },
                {
                    title: true,
                    name: 'Menu Management Astra',
                    wrapper: {
                        // optional wrapper object
                        element: '', // required valid HTML5 element tag
                        attributes: {} // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: '' // optional class names space delimited list for title item ex: "text-center"
                },
                {
                    name: 'Dashboard AFC',
                    url: '/dashboard',
                    icon: 'icon-speedometer'
                },
                {
                    name: 'Lihat Assessment',
                    url: '/lihat-asesment',
                    icon: 'icon-note'
                },
                {
                    name: 'Data Assessment',
                    url: '/data-asesment',
                    icon: 'icon-doc'
                },

                {
                    name: 'Change Role',
                    url: '/change-role',
                    icon: 'fa fa-address-card'
                }
            ]
        };
    } else if (roleId === 5) {
        navigation = {
            items: [
                {
                    name: 'Home',
                    url: '/home',
                    icon: 'icon-home'
                },
                {
                    title: true,
                    name: 'PIC Perusahaan',
                    wrapper: {
                        // optional wrapper object
                        element: '', // required valid HTML5 element tag
                        attributes: {} // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: '' // optional class names space delimited list for title item ex: "text-center"
                },
                {
                    name: 'Input Assessment AFC',
                    url: '/input-asesment',
                    icon: 'icon-note'
                },
                // di hide atas permintaan
                // {
                //     name: 'Data Assessment',
                //     url: '/data-asesment',
                //     icon: 'icon-doc'
                // },
                // {
                //     name: 'Lihat Assessment',
                //     url: '/lihat-asesment',
                //     icon: 'icon-note'
                // },
                {
                    name: 'Change Role',
                    url: '/change-role',
                    icon: 'fa fa-address-card'
                }
            ]
        };
    } else if (roleId === 6) {
        navigation = {
            items: [
                {
                    name: 'Home',
                    url: '/home',
                    icon: 'icon-home'
                },
                {
                    title: true,
                    name: 'Assessor',
                    wrapper: {
                        // optional wrapper object
                        element: '', // required valid HTML5 element tag
                        attributes: {} // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: '' // optional class names space delimited list for title item ex: "text-center"
                },
                {
                    name: 'Dashboard AFC',
                    url: '/dashboard',
                    icon: 'icon-speedometer'
                },
                {
                    name: 'Input Assessment AFC',
                    url: '/input-asesment',
                    icon: 'icon-note'
                },
                {
                    name: 'Data Assessment',
                    url: '/data-asesment',
                    icon: 'icon-doc'
                },
              
                {
                    name: 'Change Role',
                    url: '/change-role',
                    icon: 'fa fa-address-card'
                }
            ]
        };
    } else if (roleId === 7) {
        navigation = {
            items: [
                {
                    name: 'Home',
                    url: '/home',
                    icon: 'icon-home'
                },
                {
                    title: true,
                    name: 'Kepala Perusahaan',
                    wrapper: {
                        // optional wrapper object
                        element: '', // required valid HTML5 element tag
                        attributes: {} // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: '' // optional class names space delimited list for title item ex: "text-center"
                },
                {
                    name: 'Dashboard AFC',
                    url: '/dashboard',
                    icon: 'icon-speedometer'
                },
                {
                    name: 'Lihat Assessment',
                    url: '/lihat-asesment',
                    icon: 'icon-note'
                },
                {
                    name: 'Data Assessment',
                    url: '/data-asesment',
                    icon: 'icon-doc'
                },
                {
                    name: 'Change Role',
                    url: '/change-role',
                    icon: 'fa fa-address-card'
                }
            ]
        };
    }
}

export default navigation;
